// Auth Service (Web - Browser flow with cookies)
// Note: With browser flows, session is maintained via HTTP-only cookies
// GraphQL auth is handled by Oathkeeper proxy which validates cookies

// Extract user info from session
export const getUserFromSession = (
  session: any | null,
): {
  id: string;
  email: string;
  name: string;
  verified: boolean;
} | null => {
  if (!session?.identity) {
    return null;
  }

  const identity = session.identity;
  const traits = identity.traits as Record<string, any>;

  return {
    id: identity.id,
    email: traits?.email || '',
    name: traits?.name?.first
      ? `${traits.name.first} ${traits.name.last || ''}`.trim()
      : traits?.name || '',
    verified:
      identity.verifiable_addresses?.some((a: any) => a.verified) || false,
  };
};
